import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export function BillRequestedScreen({
  session,
  total,
  onClose,
  themeColor = "#f97316"
}) {
  const { t } = useTranslation();
  const formatPrice = (amount) => `${amount.toFixed(2).replace(".", ",")}€`;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
      data-testid="bill-requested-screen"
    >
      <div className="bg-white dark:bg-zinc-900 rounded-2xl p-6 max-w-sm mx-4 text-center shadow-xl">
        <div
          className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center"
          style={{ backgroundColor: `${themeColor}15` }}
        >
          <svg className="w-8 h-8" style={{ color: themeColor }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <h2 className="text-xl font-bold mb-2">{t("tableSession.billRequested", "Bill Requested!")}</h2>
        <p className="text-gray-500 mb-4">
          {t("tableSession.staffComingSoon", "A staff member will come to your table shortly.")}
        </p>

        <div
          className="p-4 rounded-xl mb-4"
          style={{ backgroundColor: `${themeColor}08` }}
        >
          <p className="text-sm text-gray-500 mb-1">{t("tableSession.amountToPay", "Amount to pay")}</p>
          <p className="text-3xl font-bold" style={{ color: themeColor }}>
            {formatPrice(total)}
          </p>
        </div>

        <p className="text-xs text-gray-400 mb-4">
          {t("tableSession.table", "Table {{number}}", { number: session?.table_number })} • {session?.customer_name}
        </p>

        <Button
          onClick={onClose}
          variant="outline"
          className="w-full"
          data-testid="bill-requested-close-btn"
        >
          {t("tableSession.closeBill", "Close")}
        </Button>
      </div>
    </div>
  );
}
